"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWebhookRequest = exports.UpdateWebhookRequest = void 0;
var UpdateWebhookRequest = /** @class */ (function () {
    function UpdateWebhookRequest(url, triggers, httpAuth, httpHeaders) {
        this.Url = url;
        this.HttpAuth = httpAuth;
        this.HttpHeaders = httpHeaders;
        this.Triggers = triggers;
    }
    return UpdateWebhookRequest;
}());
exports.UpdateWebhookRequest = UpdateWebhookRequest;
var CreateWebhookRequest = /** @class */ (function (_super) {
    __extends(CreateWebhookRequest, _super);
    function CreateWebhookRequest(url, triggers, httpAuth, httpHeaders, messageStream) {
        var _this = _super.call(this, url, triggers, httpAuth, httpHeaders) || this;
        _this.MessageStream = messageStream;
        return _this;
    }
    return CreateWebhookRequest;
}(UpdateWebhookRequest));
exports.CreateWebhookRequest = CreateWebhookRequest;
//# sourceMappingURL=Webhook.js.map